import { catalogIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Filing = createIcon({
  displayName: 'Filing',
  paths: [
    'M256 85.333c-47.104 0-85.333 38.229-85.333 85.333v597.333c0 47.104 38.229 85.333 85.333 85.333 0 47.104 38.229 85.333 85.333 85.333s85.333-38.229 85.333-85.333h170.667c0 47.104 38.229 85.333 85.333 85.333s85.333-38.229 85.333-85.333c47.104 0 85.333-38.229 85.333-85.333v-597.333c0-47.104-38.229-85.333-85.333-85.333h-512zM768 768h-512v-256h512v256zM256 170.667h512v256h-512v-256zM426.667 597.333c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h170.667c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-170.667zM426.667 256c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h170.667c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-170.667z'
  ],
  canvasPaths: canvasIconPaths(catalogIcon)
})
